import React, { useState } from 'react';
import { Typography, TextField, Button, CircularProgress, Paper, useMediaQuery, Switch, FormControlLabel } from "@material-ui/core";
//import { useNotify } from "react-admin";
import config from './config.json';
import moment from "moment";
import { customTheme } from "./customTheme";
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';

export default function Payment(props) {
    //const notify = useNotify();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));

    const [upiId, setUpiId] = useState("");
    const [payeeName, setPayeeName] = useState("");
    const [amount, setAmount] = useState("");
    const [productionMode, setProductionMode] = useState(false);
    const [loading, setLoading] = useState(false);
    const [verifying, setVerifying] = useState(false);
    const [verified, setVerified] = useState(false);
    const [paymentResult, setPaymentResult] = useState(null);

    const [clientId, setClientId] = useState("");
    const [clientSecretKey, setClientSecretKey] = useState("");

    const payAmount = () => {
        const savedClientId = localStorage.getItem("clientId");
        const savedClientSecretKey = localStorage.getItem("clientSecretKey");
        if (!(savedClientId != null && savedClientId.length > 0)) {
            notify("Client ID is required", "warning");
            return;
        }
        if (!(savedClientSecretKey != null && savedClientSecretKey.length > 0)) {
            notify("Client Secret Key is required", "warning");
            return;
        }

        setLoading(true);
        const data = {
            upiId,
            payeeName,
            amount,
            clientId: savedClientId,
            clientSecretKey: savedClientSecretKey,
            productionMode
        };
        fetch(`${config.HOST_NAME}/crm/v3/upiPayment`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                setLoading(false);
                setPaymentResult({
                    success: json.success,
                    message: json.success ?
                        `₹${json.data[2]} sent to ${json.data[17]} at ${moment(json.data[3], "YYYY:MM:DD HH:mm:ss").format("DD MMM, YYYY hh:mm:ss A")}`
                        :
                        `Failed to send ₹${json.data[2]} to ${json.data[17]}`
                });
            })
            .catch((error) => {
                setLoading(false);
                console.log(error);
                notify(error, "warning");
            });
    };

    const saveClientCredentials = () => {
        localStorage.setItem("clientId", clientId);
        localStorage.setItem("clientSecretKey", clientSecretKey);
        setClientId("");
        setClientSecretKey("");
        notify("Client Credentials Saved");
    };

    const verifyUPI = () => {
        const savedClientId = localStorage.getItem("clientId");
        const savedClientSecretKey = localStorage.getItem("clientSecretKey");
        if (!(savedClientId != null && savedClientId.length > 0)) {
            notify("Client ID is required", "warning");
            return;
        }
        if (!(savedClientSecretKey != null && savedClientSecretKey.length > 0)) {
            notify("Client Secret Key is required", "warning");
            return;
        }

        setVerifying(true);
        const data = {
            upiId,
            clientId: savedClientId,
            clientSecretKey: savedClientSecretKey,
            productionMode
        };
        fetch(`${config.HOST_NAME}/crm/v3/verifyUpi`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                setVerifying(false);
                if (json.success) {
                    setVerified(true);
                    setPayeeName(json.data.name);
                } else {
                    notify(json.message === "NA" ? "Error" : json.message, "warning");
                }
            })
            .catch((error) => {
                setVerifying(false);
                notify(error, "warning");
            });
    };

    const onProducationModeChanged = event => {
        setProductionMode(event.target.checked);
        setVerified(false);
    };

    return (
        <Paper style={{ padding: isSmallDevice ? "0 22px 25px" : "25px 22px", boxShadow: isSmallDevice ? "none" : undefined }}>
            <div style={{ borderBottom: "1px solid #ddd", alignItems: "center", paddingBottom: 15, marginBottom: 20, textAlign: "center" }}>
                <Typography>Payment</Typography>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: isSmallDevice ? "auto" : "60% 40%" }}>
                <div>
                    <FormControlLabel
                        control={<Switch checked={productionMode} onChange={onProducationModeChanged} />}
                        label="Production Mode"
                        style={{ marginBottom: 20 }}
                    />
                    <div style={{ marginBottom: 20, display: "flex", alignItems: "center" }}>
                        <TextField
                            variant="outlined"
                            size="small"
                            label="UPI ID"
                            value={upiId}
                            onChange={event => {
                                setUpiId(event.target.value);
                                setVerified(false);
                            }}
                            style={{ marginRight: 20 }}
                        />
                        {verified ?
                            <Typography variant="body1" color="primary">Verified!</Typography>
                            :
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={verifyUPI}
                                disabled={upiId === "" || verifying || loading}
                                style={{ textTransform: "none" }}
                            >
                                {verifying ? "Verifying..." : "Verify"}
                                {verifying && <CircularProgress color="inherit" size={14} style={{ marginLeft: 15 }} />}
                            </Button>
                        }
                    </div>
                    <TextField
                        variant="outlined"
                        size="small"
                        label="Payee Name"
                        value={payeeName}
                        onChange={event => setPayeeName(event.target.value)}
                        style={{ display: "block", marginBottom: 20 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        label="Amount"
                        value={amount}
                        onChange={event => {
                            if (!isNaN(event.target.value))
                                setAmount(event.target.value);
                        }}
                        onBlur={event => setAmount(event.target.value === "" ? 0 : parseFloat(event.target.value))}
                        style={{ display: "block", marginBottom: 20 }}
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={payAmount}
                        disabled={upiId === "" || payeeName === "" || amount === "" || amount === 0 || loading}
                        style={{ textTransform: "none" }}
                    >
                        {loading ? "Processing..." : "Pay"}
                        {loading && <CircularProgress color="inherit" size={14} style={{ marginLeft: 15 }} />}
                    </Button>

                    {paymentResult && <Typography variant="h6" style={{ marginTop: 25, fontSize: 16 }} color={paymentResult.success ? "primary" : "error"}>{paymentResult.message}</Typography>}
                </div>
                <div style={isSmallDevice ? { marginTop: 40, paddingTop: 20, borderTop: "1px solid #ddd" } : { borderLeft: "1px solid #ddd", paddingLeft: "6%" }}>
                    <TextField
                        variant="outlined"
                        size="small"
                        label="Client ID"
                        value={clientId}
                        onChange={event => setClientId(event.target.value)}
                        style={{ display: "block", marginBottom: 20 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        label="Client Secret Key"
                        value={clientSecretKey}
                        onChange={event => setClientSecretKey(event.target.value)}
                        style={{ display: "block", marginBottom: 20 }}
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={saveClientCredentials}
                        disabled={clientId === "" || clientSecretKey === ""}
                        style={{ textTransform: "none" }}
                    >
                        Save
                    </Button>
                </div>
            </div>
        </Paper>
    );
}